angular.module('callX').controller('LeadExportCSVCtrl', ['$scope', '$modalInstance', 'object', function($scope, $modalInstance, object) {

    $scope.obj = object;
    $scope.cancel = function () {
        $modalInstance.dismiss('cancel');
    };
}]);